import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "jr-rounded-md jr-z-10 jr-bg-white jr-px-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "jr-text-xxs" }, "設定エリア", -1)
const _hoisted_3 = { class: "jr-mt-1.5 jr-mb-2 jr-text-primary" }
const _hoisted_4 = { class: "jr-flex jr-items-center jr-mb-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア1 (主)", -1)
const _hoisted_6 = { class: "jr-flex jr-items-center jr-mb-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア2 (従)", -1)
const _hoisted_8 = { class: "jr-flex jr-items-center jr-mb-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア3 (従)", -1)
const _hoisted_10 = { class: "jr-flex jr-items-center jr-mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア4 (従)", -1)
const _hoisted_12 = { class: "jr-flex jr-items-center jr-mb-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア5 (従)", -1)
const _hoisted_14 = { class: "jr-flex jr-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "jr-mr-2.5 jr-text-xxs" }, "エリア6 (従)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.first })
        }, null, 4)
      ]),
      _createElementVNode("li", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.second })
        }, null, 4)
      ]),
      _createElementVNode("li", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.third })
        }, null, 4)
      ]),
      _createElementVNode("li", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.fourth })
        }, null, 4)
      ]),
      _createElementVNode("li", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.fifth })
        }, null, 4)
      ]),
      _createElementVNode("li", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", {
          class: "jr-w-3.5 jr-h-3.5",
          style: _normalizeStyle({ 'background-color': _ctx.sixth })
        }, null, 4)
      ])
    ])
  ]))
}